import React from 'react';
import Card from '@material-ui/core/Card';
import {CardHeader, CardContent} from '@material-ui/core';
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import {useTranslation} from "react-i18next";
import _ from "lodash";
import CancelIcon from "@material-ui/icons/Cancel";

interface ISignal {
    key: string;
    name: string;
    value: boolean;
}
interface SignalsCardProps {
    name: string;
    signals: ISignal[];
    values: object
}

const RelaysCard: React.FC<SignalsCardProps> = (props: SignalsCardProps) => {
    const {t} = useTranslation();
    const getCurrentValue = (key: string) => {
        return parseInt(_.get(props.values, key, "0"), 10) === 0 ? false : true;
    }
    const renderProperIcon = (status: boolean) => {
        if (status) {
            return (
                <CheckCircleIcon className={'check-circle'}/>
            )
        }
        return (
            <CancelIcon className={'highlight-off'}/>
        )
    }
    return (
        <Card className='signals-card'>
            <CardHeader title={props.name} className='signals-card-header'>
            </CardHeader>
            <CardContent className='signals-card-content'>
                {props.signals.map((input) => <div className='signals-card-content-item'>{input.name}{renderProperIcon(getCurrentValue(input.key))}</div>)}
            </CardContent>
        </Card>
    )
};

export default RelaysCard;